import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications } from '../helpers';
import { DeletePlaylistDocument } from './delete.generated';

export const useDeletePlaylist = () => {
  const { t } = useTranslation();

  return useMutation(DeletePlaylistDocument, {
    ...useNotifications(DeletePlaylistDocument, {
      failure: t('api.common.error_generic'),
      success: (data) => {
        const count = data.deletePlaylist?.deletedIds.length ?? 0;
        return t('api.playlists.delete_success_plural', { count });
      },
    }),
    update(cache, { data }) {
      if (!data?.deletePlaylist?.deletedIds.length) return;
      data.deletePlaylist.deletedIds.forEach((id) => cache.evict({ id: `Playlist:${id}` }));
    },
  });
};
